import { Link } from "@reach/router";
import { Heading } from "components/Heading";
import { useCurrentCompany } from "hooks/auth";
import styled from "styled-components";

import { ReactComponent as BGError } from "../../src/assets/img/not-found-bg.svg";

const NotFoundStyled = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

type NotFoundProps = {
	default?: boolean; // allows passing default to <Router>
};

export const NotFound: React.FC<NotFoundProps> = ({ default: _default }) => {
	const currentCompany = useCurrentCompany();
	const isClient = currentCompany?.profile_type?.id === 1;
	const companyId = currentCompany?.id;
	const redirectPath = companyId
		? `/account/${companyId}/${isClient ? "projects" : "rfx"}`
		: `/account/rfx`;
	if (!companyId) return null;
	return (
		<NotFoundStyled>
			<div className="relative mx-auto mt-[10vh] h-[90vh] max-h-[680px] w-full max-w-[1280px]">
				<BGError className="absolute left-1/2 top-1/2 z-10 h-full w-full -translate-x-1/2 -translate-y-1/2" />
				<div className="relative top-[45%] z-20 -translate-y-1/2 space-y-6 text-center">
					<Heading className="text-[160px] !leading-[1] !text-white">
						404
					</Heading>
					<Heading className="text-[48px] !text-utility-brand-300">
						Page not found
					</Heading>
					<p className="font-roboto text-xl text-white">
						The page you are looking for might have been removed <br /> or is
						temporarily unavailable.
					</p>
					<Link
						className="mx-auto !mt-12 block h-[60px] w-[180px] rounded-sm !bg-white px-6 py-4 font-roboto font-semibold leading-[30px] !text-royal-blue"
						to={redirectPath}
					>
						Go to homepage
					</Link>
				</div>
			</div>
		</NotFoundStyled>
	);
};
